import * as React from 'react';
import { ToggleButton } from '../../components/Promos';

interface IToggleButtonProps {
  opened: boolean;
  onClick(): void;
}

export const ToggleButtonContainer: React.FC<IToggleButtonProps> = props => {
  return <ToggleButton onClick={props.onClick} text={props.opened ? 'Скрыть' : 'Показать все акции'} />;
};
